import React, { useContext } from "react"
import classnames from "classnames"
import { ThemeContext } from "../layout"
import "./Loading.scss"

function Loading() {
  const currentTheme = useContext(ThemeContext)
  return (
    // <div
    //   className={classnames("spinner", {
    //     "spinner-dark": currentTheme === "dark",
    //   })}
    // />
    <div
      className={classnames("bg-loader", {
        "is-dark": currentTheme === "dark",
      })}
    >
      <div className="body">
        <span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </span>
        <div className="base">
          <span></span>
          <div className="face"></div>
        </div>
      </div>
      <div className="longfazers">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <h1>Fetching the resources</h1>
    </div>
  )
}

export default Loading
